import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from "@angular/core";
import { SHARED_ENVIRONMENT } from '@k12/environment';
import { EmployeeSchoolOption, EmployeeSummary, ProviderInfoStatus, SubService } from '@k12/models';
import { Observable } from 'rxjs';

export interface PagePayload {
  filter: {
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string;
    orderDirection?: number;
    searchTerm?: string;
  }
}

@Injectable({
  providedIn: 'root'
})

export class ProviderService {
  private readonly sharedEnvironment = inject(SHARED_ENVIRONMENT);
  private readonly apiUrl = this.sharedEnvironment.adminApiUrl;
  private readonly http = inject(HttpClient);

  deleteEmployee(employeeId: string): Observable<void> {
    return this.http.delete<void>(this.apiUrl + "/partners/employees/" + employeeId);
  }

  getAllEmployeesSummaryAdmin(programPartnerId: string, payload?: PagePayload): Observable<EmployeeSummary[]> {
    return this.http.post<EmployeeSummary[]>(`${this.apiUrl}/partners/${programPartnerId}/employees/summary`, payload);
  }

  getAllEmployeesSummary(): Observable<EmployeeSummary[]> {
    return this.http.get<EmployeeSummary[]>(`${this.apiUrl}/partners/employees/summary`);
  }

  getSubServices(employeeType?: number): Observable<SubService[]> {
    const url = (employeeType) ? `partners/employees/subservices?employeeType=${employeeType}` : `partners/employees/subservices`;
    return this.http.get<SubService[]>(`${this.apiUrl}/${url}`);
  }

  /** NSC degree-institution catalog (~6,000 rows), reused from the Add/Edit Employee school picker. */
  getSchools(): Observable<EmployeeSchoolOption[]> {
    return this.http.get<EmployeeSchoolOption[]>(`${this.apiUrl}/partners/schools`);
  }

  setEnrollmentStatus(status: ProviderInfoStatus | string): ProviderInfoStatus {
    return status === ProviderInfoStatus.Review || status === 'UnderReview'
      ? ProviderInfoStatus.UnderReview
      : status as ProviderInfoStatus;
  }
}